import React from 'react';
import classNames from 'classnames';
import Button from './Button';

class CookieConsent extends React.Component {

  state = {
    isVisible: false
  }

  componentDidMount() {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay
      setTimeout(() => {
        this.setState({ isVisible: true });
      }, 1000);
    }
  }

  handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    this.setState({ isVisible: false });
  }

  handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    this.setState({ isVisible: false });
  }

  render() {
    if (!this.state.isVisible) {
      return null;
    }

    return (
      <div 
        className="cookie-consent"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#101D2D',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          padding: '20px',
          zIndex: 9999,
          boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)'
        }}
      >
        <div className="container">
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px'
          }}>
            <div style={{ flex: '1', minWidth: '250px' }}>
              <p className="text-sm mb-0" style={{ margin: 0 }}>
                We use cookies to enhance your browsing experience and analyze site traffic. By clicking "Accept", you consent to our use of cookies.{' '}
                <a href="#/" style={{ color: 'var(--color-primary)', textDecoration: 'underline' }}>Learn more</a>
              </p>
            </div>
            <div style={{ 
              display: 'flex', 
              gap: '12px',
              flexWrap: 'wrap'
            }}>
              <Button 
                color="dark" 
                onClick={this.handleDecline}
                style={{ minWidth: '100px' }}
              >
                Decline
              </Button>
              <Button 
                color="primary" 
                onClick={this.handleAccept}
                style={{ minWidth: '100px' }}
              >
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CookieConsent;
